import { defineComponent as _defineComponent } from 'vue'
import LSkeleton from '@/components/core/Skeleton.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ShareTokenCardSkeleton',
  setup(__props) {


return { __sfc: true,LSkeleton }
}

})